import { AxleChip, IAxleChipProps } from '../displayFields/chips';

type ServiceStatusTagProps = Omit<IAxleChipProps, 'label'> & {
    // Optional because some callers don't fetch `isActive` at all. Only ever render
    //  on a definite `false` -- an unknown value should never be shown as "Inactive".
    isActive?: boolean;
};

export const ServiceStatusTag = ({ isActive, ...rest }: ServiceStatusTagProps) => {
    if (isActive === false) {
        return <AxleChip label='Inactive' thin {...rest} />;
    }
    return null;
};
